import axios from 'axios'

export const authClient = axios.create({
  baseURL: process.env.EXPO_PUBLIC_API_URL,
})

export async function authUpgrade() {
  return authClient.post<{ token: string; csrf_token: string }>(
    `/auth/upgrade`,
    {},
    {
      baseURL: window.location.origin,
    },
  )
}

// Reestabelece a sessão de cookie do core a partir do JWT guardado. O cookie
// de sessão morre ao fechar o navegador, mas o JWT sobrevive; sem esse passo,
// os downloads de mídia (PDF/ebook) retornam 401 enquanto a página segue logada.
export async function restoreSession(token: string) {
  return authClient.post(
    `/auth/session/restore`,
    {},
    {
      baseURL: window.location.origin,
      headers: { Authorization: `Bearer ${token}` },
    },
  )
}

export async function logout(csrfToken: string) {
  return authClient.delete(`/users/sign_out`, {
    baseURL: window.location.origin,
    headers: { 'X-CSRF-Token': csrfToken },
  })
}

export async function magicLinkEmail(email: string, returnURL: string) {
  const params = { user: { email, return_to: returnURL } }

  return authClient.post(`/magic_link`, params, {
    baseURL: window.location.origin,
  })
}
